// npm
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
// firebase
import { db } from '../firebase'
// components
import { Layout, PrimaryButton } from '../components'
// Mui
import Divider from '@material-ui/core/Divider'

const dateToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) 
}

const MagazineDetail = () => {
    const dispatch = useDispatch()

    // URLからmagazineIdを取得
    const selector = useSelector(state=>state)
    const path = selector.router.location.pathname
    const magazineId = path.split('/magazine/dp/')[1]

    // マガジン項目を初期化
    const [date, setDate] = useState('')
    const [image, setImage] = useState([])
    const [imagePosition, setImagePosition] = useState('')
    const [title, setTitle] = useState('')
    const [subTitle, setSubTitle] = useState('')
    const [category, setCategory] = useState('')
    const [categoryName, setCategoryName] = useState('')
    const [inputList, setInputList] = useState([{ 
        sectionType: "", 
        text: "", 
        image: [], caption: "", imagePosition: "", 
        link: "" 
    }]);

    // マガジンの内容取得
    useEffect( () => {
        if (magazineId) {
            db.collection('magazines').doc(magazineId)
              .get()
              .then(snapshot => {
                    const data = snapshot.data()
                    setImage(data.image)
                    setImagePosition(data.imagePosition)
                    setTitle(data.title)
                    setSubTitle(data.subTitle)
                    setCategory(data.category)
                    setDate(data.created_at)
              })
        } 
        return null
    }, [magazineId])
    // マガジンのセクション内容取得
    useEffect( () => {
        if (magazineId) {
            db.collection('magazines').doc(magazineId)
              .collection('sections')
              .orderBy('order','asc')
              .get()
              .then(snapshots=>{
                    const sectionTempList = []
                    snapshots.forEach(snapshot => {
                        const section = snapshot.data()
                        sectionTempList.push(section)
                    })
                    setInputList(sectionTempList)
              })
        }
        return null
    }, [magazineId])
    // カテゴリ名取得
    useEffect(()=>{
        if(category){
            db.collection('categories')
              .doc(category)
              .get()
              .then(snapshot => {
                    const data = snapshot.data()
                    setCategoryName(data.name)
              })
        }
        return null
    }, [category])

    return (
        <Layout>
            <MagazineDetailWrapper>
                <div className='spacer-100'></div>

                <MagazineHeader>
                    {imagePosition === 'left' && (
                        <MagazineTitleWrapper>
                            <MagazineImg src={image.path} alt={'magazine'} />
                        </MagazineTitleWrapper>
                    )}
                    <MagazineTitleWrapper>
                        <p>{categoryName}</p>
                        <div className='spacer-50' />
                        <MagazineTitle>{title}</MagazineTitle>
                        <div className='spacer-25' />
                        <Date>{date ? dateToString(date.toDate()) : ''}</Date>
                        <div className='spacer-50' />
                        <p>{subTitle}</p>
                    </MagazineTitleWrapper>
                    {imagePosition === 'right' && (
                        <MagazineTitleWrapper>
                            <MagazineImg src={image.path} alt={'magazine'} />
                        </MagazineTitleWrapper>
                    )}
                </MagazineHeader>
            
                <div className='spacer-50'></div>
                <Divider />
                <div className='spacer-50'></div>

                {inputList.map((x, i) => {
                    return (
                        <MagazineSection key={i}>
                            { x.sectionType === "text" && (    
                                <DecoratedText dangerouslySetInnerHTML={{__html: x.text}}/>
                            )}
                            { x.sectionType === "image" && ( 
                                <ImageSection>
                                    {x.imagePosition === "right" && (
                                        <CaptionWrapper>
                                            <p>{x.caption}</p>
                                        </CaptionWrapper>
                                    )}
                                    {x.imagePosition === "center" ? (
                                        <ImageWrapper1Col>
                                            <MagazineImg src={x.image.path} />
                                        </ImageWrapper1Col>
                                    ):(
                                        <ImageWrapper>
                                            <MagazineImg src={x.image.path} />
                                        </ImageWrapper>
                                    )}
                                    {x.imagePosition === "left" && (
                                        <CaptionWrapper>
                                            <p>{x.caption}</p>
                                        </CaptionWrapper>
                                    )}
                                </ImageSection>
                            )}
                            { x.sectionType === "link" && ( 
                                <div>{x.link}</div>
                            )}
                            <div className='spacer-50'></div>
                        </MagazineSection>
                    );
                })}

                <div className='spacer-50'></div>
                
                <div style={{textAlign:'center'}}>
                    <PrimaryButton label="Back to List" operation={()=>dispatch(push('/magazine'))}/>
                </div>
            </MagazineDetailWrapper>
            <div className='spacer-100'></div>
        </Layout>
    )
}
export default MagazineDetail


const MagazineDetailWrapper = styled.section`
    width: 1040px;
    margin: 0 auto;
    line-height: 1.5;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`
const MagazineHeader = styled.section`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    @media screen and (max-width:768px){
        flex-direction: column;
    }
`
const MagazineTitleWrapper = styled.div`
    width: 50%;
    padding: 20px;
    @media screen and (max-width:768px){
        width: 100%;
    }
`
const MagazineTitle = styled.h1`
    font-size: 3rem !important;
    line-height: 1.1;
    text-align: left;
    position: relative;
    &:before {
        position: absolute;
        bottom: -40px;
        left: 0;
        width: 55%;
        height: 10px;
        content: '';
        background: #fff;
    }
    &:after {
        position: absolute;
        bottom: -50px;
        right: 0;
        width: 55%;
        height: 1px;
        content: '';
        background: #fff;
    }
`
const Date = styled.div`
    font-size: .9rem;
    text-align: right;
`
const MagazineImg = styled.img`
    width: 100%;
    max-height: 100%;
    object-fit: contain;
`
const MagazineSection = styled.section`
    width: 640px;
    margin: 0 auto;
    font-size: 1.15rem;
    p {
        font-size: 18px;
        line-height: 32px;
    }
    @media screen and (max-width:768px){
        width: 100%;
    }
`
const ImageSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`
const ImageWrapper = styled.div`
    height: 254px !important;
    max-width: 60%;
    @media screen and (max-width:768px){
        height: 184px;
    }
`
const ImageWrapper1Col = styled(ImageWrapper)`
    height: auto !important;
    width: 100%;
    max-width: 100%;
`
const CaptionWrapper = styled.div`
    width: 40%;
    padding: 20px;
    font-size: .75rem;
    position: relative;
    &:before {
        position: absolute;
        top: 0;
        left: 20px;
        width: 50px;
        height: 5px;
        content: '';
        background: #fff;
    }
    &:after {
        position: absolute;
        bottom: 0;
        right: 20px;
        width: 55%;
        height: 1px;
        content: '';
        background: #fff;
    }
    p {
        font-size: .8rem;
    }
`
const DecoratedText = styled.div`
    letter-spacing: .05rem;
    line-height: 2rem;
    ul {
        list-style: disc;
        padding-left: 30px;
    }
    ol {
        list-style: decimal;
        padding-left: 30px;
    }
`